import { Injectable, inject } from '@angular/core';

import type { Observable } from 'rxjs';

import { HttpApiService } from '@core/http-legacy';
import type { LocationsCounters } from '@core/locations-types';

@Injectable({ providedIn: 'root' })
export class LocationsCountersHttpClient {
  protected readonly httpApi = inject(HttpApiService);

  public fetch(): Observable<{ counters: LocationsCounters }> {
    return this.httpApi.get(`/locations/counters`);
  }
}
